import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../../contexts/PageContext';

import './CallToActionButtons.scss';

export default class CallToActionButtons extends React.PureComponent {
    constructor(props) {
        super(props);

        this.buttons = {
            FOLLOW: {
                action: 'follow',
                label: 'Follow',
                altLabel: 'Following',
                classes: 'purple-white-btn',
                altClasses: 'white-grey-btn',
                loginDescription: 'follow-company',
            },
            INVITE: {
                link: '/users/connections/invite',
                label: 'Invite Friends',
                classes: 'white-grey-btn sticky-hide',
            },
            REVIEW: {
                link: this.props.userId
                    ? '/company/review-' + this.props.companyUrl
                    : '/please-register',
                label: 'Write a Review',
                classes: 'white-grey-btn sticky-hide',
            },
        };
    }
    static propTypes = {
        /**
         * The company's url hash
         */
        companyUrl: PropTypes.string,
        /**
         * The company's ID
         */
        companyId: PropTypes.number,
        /**
         *  does user follow company
         */
        isFollowed: PropTypes.bool,
        /**
         * The company's follow callback
         */
        followCompany: PropTypes.func,
        /**
         * The company's unfollow callback
         */
        unfollowCompany: PropTypes.func,
        /**
         *  session userId
         */
        userId: PropTypes.number,
        /**
         *  auth wrapper
         */
        wrapAuth: PropTypes.func,
        companyName: PropTypes.string,
    };

    static defaultProps = {
        companyUrl: '',
        followCompany: () => {},
        unfollowCompany: () => {},
    };

    handleFollowClick = () => {
        !this.props.isFollowed
            ? this.props.followCompany(this.props.companyId, this.props.userId)
            : null;
    };

    renderButtonWrapper = (
        buttonKey,
        wrapAuth,
        contextSurveyTrigger,
        isLoggedIn
    ) => {
        const buttonData = this.buttons[buttonKey];
        const classes = `company-header-button ${
            this.props.isFollowed && buttonData.altClasses
                ? buttonData.altClasses
                : buttonData.classes
        }`;
        const value =
            this.props.isFollowed && buttonData.altLabel
                ? buttonData.altLabel
                : buttonData.label;
        const buttonInput = (
            <input
                type="button"
                readOnly
                className="lato-bold"
                value={value}
                key={buttonKey}
            />
        );
        let usedButton = (
            <a href={buttonData.link} className={classes} key={buttonKey}>
                {buttonInput}
            </a>
        );
        const company = {
            companyName: this.props.companyName,
            companyId: this.props.companyId,
            logo: this.props.logo,
        };
        if (buttonData.action) {
            usedButton = wrapAuth(
                'company-header',
                <div
                    onClick={isLoggedIn ? this.handleFollowClick : () => {}}
                    className={classes}
                    key={buttonKey}
                >
                    {buttonInput}
                </div>,
                { login_trigger: buttonData.loginDescription }
            );
        } else if (buttonKey === 'REVIEW') {
            usedButton = (
                <div
                    onClick={() => contextSurveyTrigger(true, company)}
                    className={classes}
                    key={buttonKey}
                >
                    {buttonInput}
                </div>
            );
        }

        return usedButton;
    };

    render() {
        return (
            <React.Fragment>
                <PageConsumer>
                    {(context) => {
                        return ['FOLLOW', 'INVITE', 'REVIEW'].map((key) =>
                            this.renderButtonWrapper(
                                key,
                                context.wrapAuth,
                                context.toggleJobReviewSurvey,
                                context.isLoggedIn()
                            )
                        );
                    }}
                </PageConsumer>
            </React.Fragment>
        );
    }
}
